import { createApp } from 'vue';
import PsychologicalD1PTable from '../../psychology-report/D1PTable.vue'

// Allow multiple Vue apps in the same page
const appElements = document.querySelectorAll('.vue-psychology-render-d1')

Array.from(appElements).forEach(element => {
  createApp(PsychologicalD1PTable).mount(element);
});